module.exports = __webpack_public_path__ + "img/eazis-pulse.41f2faba.png";